/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-param-reassign */
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';

export const EVENT_NAME = {
    STATUS_BAR_READY_DISPLAY: 'STATUS_BAR_READY_DISPLAY',
    LEFT_BAR_READY_DISPLAY: 'LEFT_BAR_READY_DISPLAY',
    HELP_CENTER_READY_DISPLAY: 'HELP_CENTER_READY_DISPLAY',
    BADGE_MOVE_READY_DISPLAY: 'BADGE_MOVE_READY_DISPLAY',
    BADGE_READY_DISPLAY: 'BADGE_READY_DISPLAY',
};
// 动画执行间隔时间
export const ANIM_INTERVAL = 300;
// 最长等待超时时间
export const MAX_TIMEOUT = 2000;
// 最高优先级
export const HIGHTEST_PRIORITY = -9999;

export const ELEMENT = {
    HELP_CENTER_WRAPPER: 'help-center-wrapper',
    TOOLBAR_CONTAINER: 'toolbar-container',
    DOUBLE_TOOLBAR_CONTAINER: 'double_toolbar_container',
    LEFT_BAR_CONTAINER: 'left-bar-container',
    STATUS_BAR_CONTAINER: 'status-bar-container',
};

export const loadQueueByOrder: any = [
    {
        name: EVENT_NAME.STATUS_BAR_READY_DISPLAY,
        order: 1,
        style: {
            before: {
                transform: 'translate(0, 32px)',
                opacity: 0,
            },
            after: {
                transform: 'translate(0, 0)',
                opacity: 1,
                transition: 'all .3s',
            },
        },
    },
    {
        name: EVENT_NAME.HELP_CENTER_READY_DISPLAY,
        order: 2,
        style: {
            before: {
                opacity: 0,
            },
            after: {
                transition: 'all .3s',
                opacity: 1,
            },
        },
    },
    {
        name: EVENT_NAME.LEFT_BAR_READY_DISPLAY,
        order: 2,
        style: {
            before: {
                opacity: 0,
            },
            after: {
                transition: 'all .3s',
                opacity: 1,
            },
        },
    },
].sort((v1, v2) => v1.order - v2.order);

export const waitingToLoadQueue: {
    el: HTMLElement;
    name: string;
    order: number;
    style: any;
}[] = [];

export function sortAndGetMinOrder(queueByOrder) {
    queueByOrder.sort((v1, v2) => v1.order - v2.order);
    return Math.min(...queueByOrder.map(({ order }) => order));
}

// 比对 loadQueue 和 waitingToLoadQueue 中的最小 order，判断是否该执行
export function checkIfShouldDisplay() {
    const minLoadOrder = sortAndGetMinOrder(loadQueueByOrder);
    const minWaitOrder = sortAndGetMinOrder(waitingToLoadQueue);
    if (minLoadOrder > minWaitOrder) {
        requestAnimationFrame(display);
    }
}

// 执行 waitingToLoadQueue 的第一项
export function display() {
    const waitingToLoadItem = waitingToLoadQueue.shift();
    if (!waitingToLoadItem) return;
    applyStyle('after', waitingToLoadItem);
    setTimeout(() => {
        checkIfShouldDisplay();
    }, ANIM_INTERVAL);
}

/**
 * 处理事件监听，收集待执行的 cb
 * @param readyToLoadItem
 * @param el
 */
export function collectReadyToLoadItem(readyToLoadItem, el) {
    const readyToLoadIndex = loadQueueByOrder.indexOf(readyToLoadItem);
    loadQueueByOrder.splice(readyToLoadIndex, 1);
    waitingToLoadQueue.push({ ...readyToLoadItem, el });
    applyStyle('before', { ...readyToLoadItem, el });
    checkIfShouldDisplay();
}

export function applyStyle(type, { style, el }) {
    if (!style[type] || !el || !el.style) return;
    Object.keys(style[type]).forEach((key) => {
        el.style[key] = style[type][key];
    });
}

export function controlCb({ name, el }) {
    const readyToLoadItem = loadQueueByOrder.find(item => item.name === name);
    if (!readyToLoadItem) {
        if (!loadQueueByOrder.length) {
            window.log?.info('no need to control load');
        }
        return;
    }
    collectReadyToLoadItem(readyToLoadItem, document.querySelector(el));
}

// 对第三方组件的监听
export function watchComponent() {
    eventBus.on(EventKeys.CONTROL_EVENT, controlCb);
}

// 对第三方组件取消监听
export function unWatchComponent() {
    eventBus.off(EventKeys.CONTROL_EVENT, controlCb);
}
export function start() {
    watchComponent();
    setTimeout(() => {
        if (waitingToLoadQueue.length !== 0) {
            waitingToLoadQueue.forEach(item => item.order = HIGHTEST_PRIORITY);
            checkIfShouldDisplay();
        }
    }, MAX_TIMEOUT);
}
